module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-1.96ba18ad.jpg";